/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.5.2",
    versionName: "0.2.0-nightly.2026.5.2",
    versionChannel: "nightly",
    buildDate: "2026-05-02T00:23:48.514Z",
    commitHash: "9d2b318eadcd87a7dc0bc5bfe643c6791061397e",
};
